import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { authApi, adminApi, organizationApi } from '../services/api';
import Layout from '../components/layout/Layout';
import CustomSelect from '../components/common/CustomSelect';

export default function ProfileSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: authUser, refreshUser } = useAuth();
  const [mustSetup2fa, setMustSetup2fa] = useState(() => typeof window !== 'undefined' && localStorage.getItem('requires_2fa_setup') === '1');
  const [currentUser, setCurrentUser] = useState(authUser ?? null);

  const countries = [
    { code: '', name: 'Select country' },
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BR', name: 'Brazil' },
    { code: 'BN', name: 'Brunei' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'EE', name: 'Estonia' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'GR', name: 'Greece' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JP', name: 'Japan' },
    { code: 'KR', name: 'Korea (South)' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MX', name: 'Mexico' },
    { code: 'MA', name: 'Morocco' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NO', name: 'Norway' },
    { code: 'PA', name: 'Panama' },
    { code: 'PE', name: 'Peru' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'ES', name: 'Spain' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'TR', name: 'Turkey' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Vietnam' },
  ];
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    title: '',
    office: '',
    mobile: '',
    city: '',
    country: '',
    visibility: 0,
  });
  const [avatar, setAvatar] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState('profile');
  const [twoFaEnabled, setTwoFaEnabled] = useState(false);
  const [twoFaSetup, setTwoFaSetup] = useState(null);
  const [twoFaCode, setTwoFaCode] = useState('');
  const [disable2faPassword, setDisable2faPassword] = useState('');
  const [loading2fa, setLoading2fa] = useState(false);
  const [organization, setOrganization] = useState(null);
  const [organizationData, setOrganizationData] = useState({
    description: '',
    website: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    country: '',
    contact_person_name: '',
    contact_person_title: '',
    contact_person_email: '',
    contact_person_phone: '',
  });

  // Sync from auth context when it becomes available or when opening the page
  useEffect(() => {
    if (authUser) {
      setCurrentUser(authUser);
      if (authUser.user_info) {
        setFormData({
          first_name: authUser.user_info.first_name || '',
          last_name: authUser.user_info.last_name || '',
          title: authUser.user_info.title || '',
          office: authUser.user_info.office || '',
          mobile: authUser.user_info.mobile || '',
          city: authUser.user_info.city || '',
          country: authUser.user_info.country || '',
          visibility: authUser.user_info.visibility || 0,
        });
        const avatarValue = authUser.user_info.avatar || localStorage.getItem('user_avatar');
        setAvatarPreview(toDataUrl(avatarValue));
      }
    }
  }, [authUser]);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'admin') {
      fetchOrganization();
    }
  }, []);

  useEffect(() => {
    if (location.state?.tab === 'security') {
      setActiveTab('security');
      window.history.replaceState({}, '', location.pathname);
    }
  }, [location.state?.tab, location.pathname]);

  useEffect(() => {
    if (activeTab === 'security') {
      authApi.get2faStatus().then((res) => {
        if (res.data && typeof res.data.enabled === 'boolean') setTwoFaEnabled(res.data.enabled);
      }).catch(() => {});
    }
  }, [activeTab]);

  const toDataUrl = (value) => {
    if (!value) return null;
    if (typeof value === 'string' && value.startsWith('data:')) return value;
    return `data:image/jpeg;base64,${value}`;
  };

  const fetchCurrentUser = async () => {
    try {
      const data = await refreshUser();
      if (data) {
        setCurrentUser(data);
        if (data.user_info) {
          setFormData({
            first_name: data.user_info.first_name || '',
            last_name: data.user_info.last_name || '',
            title: data.user_info.title || '',
            office: data.user_info.office || '',
            mobile: data.user_info.mobile || '',
            city: data.user_info.city || '',
            country: data.user_info.country || '',
            visibility: data.user_info.visibility || 0,
          });
          const avatarValue = data.user_info.avatar || localStorage.getItem('user_avatar');
          setAvatarPreview(toDataUrl(avatarValue));
        }
      }
    } catch (err) {
      setError('Failed to load profile');
    }
  };

  const fetchOrganization = async () => {
    try {
      // For Organization Admins, the /organizations endpoint returns their organization
      const orgsResponse = await organizationApi.getAll(0, 1);
      
      if (orgsResponse.data && orgsResponse.data.length > 0) {
        const org = orgsResponse.data[0];
        setOrganization(org);
        setOrganizationData({
          description: org.description || '',
          website: org.website || '',
          phone: org.phone || '',
          email: org.email || '',
          address: org.address || '',
          city: org.city || '',
          country: org.country || '',
          contact_person_name: org.contact_person_name || '',
          contact_person_title: org.contact_person_title || '',
          contact_person_email: org.contact_person_email || '',
          contact_person_phone: org.contact_person_phone || '',
        });
      } else {
        setError('Organization not found. Please contact your administrator.');
      }
    } catch (err) {
      console.error('Error fetching organization:', err);
      setError(err.response?.data?.detail || 'Failed to load organization information');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({ ...prev, [name]: value }));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Update user info
      await authApi.updateProfile({ userinfo: formData });
      
      // Upload avatar if changed
      if (avatar) {
        const response = await authApi.uploadMyAvatar(avatar);
        // Save avatar to localStorage for navbar
        if (response.data.avatar) {
          localStorage.setItem('user_avatar', response.data.avatar);
        }
      }

      setSuccess('Profile updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
      fetchCurrentUser();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (passwordData.new_password !== passwordData.confirm_password) {
      setError('New passwords do not match');
      setLoading(false);
      return;
    }

    try {
      await authApi.updateProfile({
        password: {
          current_password: passwordData.current_password,
          new_password: passwordData.new_password,
        }
      });
      
      setSuccess('Password changed successfully!');
      setPasswordData({ current_password: '', new_password: '', confirm_password: '' });
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      const errorDetail = err.response?.data?.detail;
      if (typeof errorDetail === 'object' && errorDetail.message) {
        setError(`${errorDetail.message}: ${errorDetail.reasons?.join(', ')}`);
      } else {
        setError(typeof errorDetail === 'string' ? errorDetail : 'Failed to change password');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSetup2fa = async () => {
    setLoading2fa(true);
    setError('');
    try {
      const res = await authApi.setup2fa();
      setTwoFaSetup(res.data);
      setTwoFaCode('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to setup 2FA');
    } finally {
      setLoading2fa(false);
    }
  };

  const handleEnable2fa = async (e) => {
    e.preventDefault();
    if (!twoFaCode || twoFaCode.length !== 6) return;
    setLoading2fa(true);
    setError('');
    try {
      await authApi.enable2fa(twoFaCode);
      setTwoFaEnabled(true);
      setTwoFaSetup(null);
      setTwoFaCode('');
      localStorage.removeItem('requires_2fa_setup');
      setMustSetup2fa(false);
      setSuccess('Two-factor authentication enabled.');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid code. Please try again.');
    } finally {
      setLoading2fa(false);
    }
  };

  const handleDisable2fa = async (e) => {
    e.preventDefault();
    if (!disable2faPassword) return;
    setLoading2fa(true);
    setError('');
    try {
      await authApi.disable2fa(disable2faPassword);
      setTwoFaEnabled(false);
      setDisable2faPassword('');
      setSuccess('Two-factor authentication disabled.');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to disable 2FA');
    } finally {
      setLoading2fa(false);
    }
  };

  const handleSaveOrganization = async (e) => {
    e.preventDefault();
    if (!organization) return;
    
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await organizationApi.update(organization.id, organizationData);
      setSuccess('Organization information updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
      fetchOrganization();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to update organization information');
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-eucnet-blue"></div>
          <p className="mt-4 text-slate-600">Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <Layout>
      {/* Page Title */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-eucnet-navy">Profile Settings</h1>
          <p className="mt-1 text-sm text-slate-600">Manage your personal information and preferences</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Messages */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
            {error}
          </div>
        )}
        {success && (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
            {success}
          </div>
        )}

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="flex border-b border-slate-200">
            <button
              onClick={() => setActiveTab('profile')}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors ${
                activeTab === 'profile'
                  ? 'text-eucnet-blue border-b-2 border-eucnet-blue bg-eucnet-grey-100'
                  : 'text-slate-600 hover:text-slate-800'
              }`}
            >
              Personal Information
            </button>
            <button
              onClick={() => setActiveTab('security')}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors ${
                activeTab === 'security'
                  ? 'text-eucnet-blue border-b-2 border-eucnet-blue bg-eucnet-grey-100'
                  : 'text-slate-600 hover:text-slate-800'
              }`}
            >
              Security
            </button>
            {currentUser?.role === 'admin' && (
              <button
                onClick={() => setActiveTab('organization')}
                className={`flex-1 px-6 py-4 text-sm font-medium transition-colors ${
                  activeTab === 'organization'
                    ? 'text-eucnet-blue border-b-2 border-eucnet-blue bg-eucnet-grey-100'
                    : 'text-slate-600 hover:text-slate-800'
                }`}
              >
                Organization Settings
              </button>
            )}
          </div>

          {/* Profile Tab */}
          {activeTab === 'profile' && (
            <form onSubmit={handleSaveProfile} className="p-6">
              {/* Avatar Section */}
              <div className="mb-8">
                <label className="block text-sm font-medium text-slate-700 mb-4">Profile Picture</label>
                <div className="flex items-center space-x-6">
                  <div className="w-32 h-32 rounded-full overflow-hidden bg-slate-200 flex items-center justify-center">
                    {avatarPreview ? (
                      <img src={avatarPreview} alt="Avatar" className="w-full h-full object-cover" />
                    ) : (
                      <span className="text-4xl text-slate-500">
                        {formData.first_name?.charAt(0)}{formData.last_name?.charAt(0)}
                      </span>
                    )}
                  </div>
                  <div>
                    <input
                      type="file"
                      id="avatar"
                      accept="image/*"
                      onChange={handleAvatarChange}
                      className="hidden"
                    />
                    <label
                      htmlFor="avatar"
                      className="cursor-pointer inline-block px-4 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy transition-colors"
                    >
                      Change Photo
                    </label>
                    <p className="text-sm text-slate-500 mt-2">JPG, PNG up to 5MB</p>
                  </div>
                </div>
              </div>

              {/* Account Information */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Account Information</h3>
                <div className="bg-eucnet-grey-100 p-4 rounded-lg space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Username:</span>
                    <span className="text-sm font-medium text-slate-900">{currentUser.username}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Email:</span>
                    <span className="text-sm font-medium text-slate-900">{currentUser.email}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Role:</span>
                    <span className={`text-sm font-semibold px-2 py-1 rounded ${
                      currentUser.role === 'global_admin'
                        ? 'bg-purple-100 text-purple-800'
                        : currentUser.role === 'assessment_admin'
                        ? 'bg-blue-100 text-blue-800'
                        : currentUser.role === 'admin'
                        ? 'bg-purple-100 text-purple-800'
                        : 'bg-slate-200 text-slate-700'
                    }`}>
                      {currentUser.role === 'global_admin' ? 'Global Admin' : 
                       currentUser.role === 'assessment_admin' ? 'Assessment Admin' :
                       currentUser.role === 'admin' ? 'Admin' : 
                       'User'}
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Organization:</span>
                    <span className="text-sm font-medium text-slate-900">
                    {currentUser.user_info?.organization && (
                      <span>{currentUser.user_info.organization.name}</span>
                    )}
                    {currentUser.user_info?.oes && (
                      <span>{currentUser.user_info.oes.name}</span>
                    )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Personal Information */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Personal Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">First Name *</label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Last Name *</label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-slate-700 mb-2">Title/Position</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Contact Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Office Phone</label>
                    <input
                      type="text"
                      name="office"
                      value={formData.office}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Mobile Phone</label>
                    <input
                      type="text"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">City</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Country</label>
                    <CustomSelect
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      options={countries.map(c => ({ value: c.code, label: c.name }))}
                      placeholder="Select country"
                    />
                  </div>
                </div>
              </div>


              {/* Save Button */}
              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </form>
          )}

          {/* Security Tab */}
          {activeTab === 'security' && (
            <div className="p-6 space-y-8">
              {mustSetup2fa && (
                <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg text-amber-900">
                  <p className="font-medium">You must enable two-factor authentication to continue using the platform.</p>
                  <p className="text-sm mt-1">Scan the QR code below with your authenticator app and enter the 6-digit code to complete setup.</p>
                </div>
              )}
              {/* Two-factor authentication */}
              <div className="border-b border-slate-200 pb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-2">Two-factor authentication (2FA)</h3>
                <p className="text-sm text-slate-600 mb-4">Use an authenticator app (e.g. Google Authenticator) to add a second factor when signing in.</p>
                {twoFaEnabled ? (
                  <div>
                    <p className="text-sm text-green-700 mb-3">2FA is enabled for your account.</p>
                    <form onSubmit={handleDisable2fa} className="flex flex-wrap items-end gap-3">
                      <div className="min-w-[200px]">
                        <label className="block text-sm font-medium text-slate-700 mb-1">Your password to disable 2FA</label>
                        <input
                          type="password"
                          value={disable2faPassword}
                          onChange={(e) => setDisable2faPassword(e.target.value)}
                          placeholder="Password"
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky"
                        />
                      </div>
                      <button type="submit" disabled={loading2fa || !disable2faPassword} className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 disabled:opacity-50">
                        {loading2fa ? 'Disabling...' : 'Disable 2FA'}
                      </button>
                    </form>
                  </div>
                ) : twoFaSetup ? (
                  <form onSubmit={handleEnable2fa}>
                    <p className="text-sm text-slate-600 mb-2">Scan the QR code with your authenticator app, then enter the 6-digit code below.</p>
                    {twoFaSetup.qr_code_base64 && (
                      <div className="mb-4">
                        <img src={twoFaSetup.qr_code_base64} alt="QR code for 2FA" className="w-40 h-40 border border-slate-200 rounded" />
                      </div>
                    )}
                    <p className="text-xs text-slate-500 mb-2">Or enter this secret manually: <code className="bg-slate-100 px-1 rounded">{twoFaSetup.secret}</code></p>
                    <div className="flex flex-wrap items-end gap-3 mb-3">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">6-digit code</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          value={twoFaCode}
                          onChange={(e) => setTwoFaCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          placeholder="000000"
                          className="w-32 px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky text-center tracking-widest"
                        />
                      </div>
                      <button type="submit" disabled={loading2fa || twoFaCode.length !== 6} className="px-4 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy disabled:opacity-50">
                        {loading2fa ? 'Enabling...' : 'Enable 2FA'}
                      </button>
                      <button type="button" onClick={() => { setTwoFaSetup(null); setTwoFaCode(''); }} className="px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50">
                        Cancel
                      </button>
                    </div>
                  </form>
                ) : (
                  <button type="button" onClick={handleSetup2fa} disabled={loading2fa} className="px-4 py-2 bg-eucnet-sky text-white rounded-lg hover:bg-eucnet-sky/90 disabled:opacity-50">
                    {loading2fa ? 'Loading...' : 'Enable 2FA'}
                  </button>
                )}
              </div>

              <form onSubmit={handleChangePassword}>
              <div className="max-w-2xl">
                <h3 className="text-lg font-semibold text-slate-800 mb-6">Change Password</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Current Password *</label>
                    <input
                      type="password"
                      name="current_password"
                      value={passwordData.current_password}
                      onChange={handlePasswordChange}
                      required
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">New Password *</label>
                    <input
                      type="password"
                      name="new_password"
                      value={passwordData.new_password}
                      onChange={handlePasswordChange}
                      required
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Confirm New Password *</label>
                    <input
                      type="password"
                      name="confirm_password"
                      value={passwordData.confirm_password}
                      onChange={handlePasswordChange}
                      required
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-6 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Changing...' : 'Change Password'}
                  </button>
                </div>
              </div>
            </form>
            </div>
          )}

          {/* Organization Settings Tab */}
          {activeTab === 'organization' && (
            organization ? (
              <form onSubmit={handleSaveOrganization} className="p-6">
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-slate-800 mb-2">Organization Information</h3>
                <div className="bg-eucnet-grey-100 p-4 rounded-lg space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Organization Name:</span>
                    <span className="text-sm font-medium text-slate-900">{organization.name}</span>
                  </div>
                  {organization.short_name && (
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">Short Name:</span>
                      <span className="text-sm font-medium text-slate-900">{organization.short_name}</span>
                    </div>
                  )}
                  {organization.sector && (
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">Sector:</span>
                      <span className="text-sm font-medium text-slate-900">{organization.sector}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Organization Details</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Description</label>
                    <textarea
                      name="description"
                      value={organizationData.description}
                      onChange={(e) => setOrganizationData({...organizationData, description: e.target.value})}
                      rows={4}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Website</label>
                    <input
                      type="url"
                      name="website"
                      value={organizationData.website}
                      onChange={(e) => setOrganizationData({...organizationData, website: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                      placeholder="https://example.com"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Contact Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Phone</label>
                    <input
                      type="text"
                      name="phone"
                      value={organizationData.phone}
                      onChange={(e) => setOrganizationData({...organizationData, phone: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={organizationData.email}
                      onChange={(e) => setOrganizationData({...organizationData, email: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Address</label>
                    <input
                      type="text"
                      name="address"
                      value={organizationData.address}
                      onChange={(e) => setOrganizationData({...organizationData, address: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">City</label>
                    <input
                      type="text"
                      name="city"
                      value={organizationData.city}
                      onChange={(e) => setOrganizationData({...organizationData, city: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Country</label>
                    <CustomSelect
                      name="country"
                      value={organizationData.country}
                      onChange={(e) => setOrganizationData({...organizationData, country: e.target.value})}
                      options={countries.map(c => ({ value: c.code, label: c.name }))}
                      placeholder="Select country"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Contact Person</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Name</label>
                    <input
                      type="text"
                      name="contact_person_name"
                      value={organizationData.contact_person_name}
                      onChange={(e) => setOrganizationData({...organizationData, contact_person_name: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Title</label>
                    <input
                      type="text"
                      name="contact_person_title"
                      value={organizationData.contact_person_title}
                      onChange={(e) => setOrganizationData({...organizationData, contact_person_title: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
                    <input
                      type="email"
                      name="contact_person_email"
                      value={organizationData.contact_person_email}
                      onChange={(e) => setOrganizationData({...organizationData, contact_person_email: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Phone</label>
                    <input
                      type="text"
                      name="contact_person_phone"
                      value={organizationData.contact_person_phone}
                      onChange={(e) => setOrganizationData({...organizationData, contact_person_phone: e.target.value})}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-eucnet-sky focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 bg-eucnet-blue text-white rounded-lg hover:bg-eucnet-navy transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
              </form>
            ) : (
              <div className="p-6">
                <div className="text-center py-12">
                  <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-eucnet-blue mb-4"></div>
                  <p className="text-slate-600">Loading organization information...</p>
                  {error && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600 max-w-md mx-auto">
                      {error}
                    </div>
                  )}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </Layout>
  );
}
